import { Container, Tab, Tabs } from "react-bootstrap";
import SubscribedTab from "./TabComponents/SubscribedTab";
import OfferingTab from "./TabComponents/OfferingTab";
import PendingTab from "./TabComponents/PendingTab";
import ListedTab from "./TabComponents/ListedTab";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../../services/axiosInstance";
import Helper from "../../utils/Helper";
import _ from "lodash";
import { React, useEffect, useState } from "react";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../selectors/auth";
import CustomConfirmationModal from "../../components/CustomConfirmationModal";
import * as ipoActions from "../../action/ipo";
import clsx from "clsx";
import UpcomingTab from "./TabComponents/UpcomingTab";

function EIPO() {
  const [token, setToken] = useState(null);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [cancelConfirmationDialog, setCancelConfirmationDialog] =
    useState(false);
  const [currentCancelID, setCurrentCancelID] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const dispatch = useDispatch();

  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  useEffect(() => {
    dispatch(ipoActions.removeIPODetail());
  }, []);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const history = useHistory();
  const offeringIPO = useQuery({
    queryKey: ["offering-ipo"],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/ipo?status=current`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch, history);
        return Promise.reject(e);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });
  const total = _.get(offeringIPO, ["data", "meta", "total"], 0);
  const upcomingIpo = useQuery({
    queryKey: ["upcoming-ipo"],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/ipo?status=upcoming`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch, history);
        return Promise.reject(e);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });
  const upcomingTotal = _.get(upcomingIpo, ["data", "meta", "total"], 0);
  const pendingIpo = useQuery({
    queryKey: ["pending-ipo"],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/ipo?status=balloting`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch, history);
        return Promise.reject(e);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });
  const pendingTotal = _.get(pendingIpo, ["data", "meta", "total"], 0);
  const pastIPO = useQuery({
    queryKey: ["past-ipo"],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/ipo?status=listed`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch, history);
        return Promise.reject(e);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });
  const pastTotal = _.get(pastIPO, ["data", "meta", "total"], 0);
  const subscribedIPO = useQuery({
    queryKey: ["subscribed-ipo"],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/ipo/subscription`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch, history);
        return Promise.reject(e);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });

  const onConfirmCancel = async () => {
    setCancelLoading(true);
    try {
      const response = await axiosInstance.del(
        `/clientarea/ipo/subscription/${currentCancelID}`,
      );
      if (response.code === 200) {
        setCurrentCancelID(null);
        setCancelConfirmationDialog(false);
        await subscribedIPO.refetch();
      }
    } catch (e) {
    } finally {
      setCancelLoading(false);
    }
  };
  return (
    <Container fluid>
      <div className={clsx("custom-card-label-container text-center")}>
        <h2>IPO</h2>
      </div>
      <div className={"primary-border-table-border"}>
        <div className="py-3">
          <div className={clsx("custom-table-info-container padding-12px")}>
            <Tabs defaultActiveKey="offering" className="mb-3 custom-tab">
              <Tab
                  eventKey="upcoming"
                  title={`${upcomingTotal > 0 ? `Upcoming (${upcomingTotal})` : "Upcoming"}`}
              >
                <UpcomingTab data={upcomingIpo} />
              </Tab>
              <Tab
                eventKey="offering"
                title={`${total > 0 ? `Offering (${total})` : "Offering"}`}
              >
                <OfferingTab data={offeringIPO}></OfferingTab>
              </Tab>
              <Tab
                  eventKey="pending"
                  title={`${pendingTotal > 0 ? `Pending Listing (${pendingTotal})` : "Pending Listing"}`}
              >
                <ListedTab data={pendingIpo}></ListedTab>
              </Tab>
              <Tab
                eventKey="listed"
                title={`${pastTotal > 0 ? `Listed (${pastTotal})` : "Listed"}`}
              >
                <ListedTab data={pastIPO} />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>

      <CustomConfirmationModal
        show={cancelConfirmationDialog}
        handleClose={() => {
          setCancelConfirmationDialog(false);
          setCurrentCancelID(null);
        }}
        confirm={onConfirmCancel}
        loading={cancelLoading}
        title="Cancel Confirmation"
        desc="Are you confirm to cancel this subsbription IPO?"
      ></CustomConfirmationModal>
    </Container>
  );
}

export default EIPO;
